import * as i0 from "@angular/core";
var StoreInquireService = /** @class */ (function () {
    function StoreInquireService() {
    }
    StoreInquireService.prototype.getLocalStorages = function (code) {
        this.storeInquire = JSON.parse(localStorage.getItem('gtc-e-commerce-galavail.dataInquire-' + code));
        this.storePalet = JSON.parse(localStorage.getItem('gtc-e-commerce-galavail.paleta-' + code));
        this.storeUrlOrigin = JSON.parse(localStorage.getItem('gtc-e-commerce-galavail.urlOrigen-' + code));
    };
    StoreInquireService.prototype.getUrlOrigin = function () {
        try {
            return this.storeUrlOrigin;
        }
        catch (error) {
            console.error('Url Origin Error', error);
        }
    };
    StoreInquireService.prototype.getCompany = function () {
        try {
            return this.storeInquire.empresa;
        }
        catch (error) {
            console.error('Company Error', error);
        }
    };
    StoreInquireService.prototype.getBoat = function () {
        try {
            return this.storeInquire.boat;
        }
        catch (error) {
            console.error('Boat Error', error);
        }
    };
    StoreInquireService.prototype.getPromotion = function () {
        try {
            return this.storeInquire.promotion;
        }
        catch (error) {
            console.error('Promotion Error', error);
        }
    };
    StoreInquireService.prototype.getCharterOnly = function () {
        try {
            return this.storeInquire.charterOnly;
        }
        catch (error) {
            console.error('Promotion Error', error);
        }
    };
    StoreInquireService.prototype.getGroupsOnly = function () {
        try {
            return this.storeInquire.groupsOnly;
        }
        catch (error) {
            console.error('Promotion Error', error);
        }
    };
    StoreInquireService.prototype.getContPromotion = function () {
        try {
            if (this.storeInquire.promotion === '2 X 1' || this.storeInquire.boat === 'Calipso' || this.storeInquire.boat === 'Calipso Diving') {
                return '';
            }
            return this.storeInquire.contPromotion;
        }
        catch (error) {
            console.error('Cont Promotion Error', error);
        }
    };
    StoreInquireService.prototype.getRackPrice = function () {
        try {
            return this.storeInquire.rackPrice;
        }
        catch (error) {
            console.error('Rack Price Error', error);
        }
    };
    StoreInquireService.prototype.getPromoPrice = function () {
        try {
            return this.storeInquire.promoPrice;
        }
        catch (error) {
            console.error('Promo Price Error', error);
        }
    };
    StoreInquireService.prototype.getStartDate = function () {
        try {
            return this.storeInquire.startDate;
        }
        catch (error) {
            console.error('Start Date Error', error);
        }
    };
    StoreInquireService.prototype.getEndDate = function () {
        try {
            return this.storeInquire.endDate;
        }
        catch (error) {
            console.error('End Date Error', error);
        }
    };
    StoreInquireService.prototype.getLength = function () {
        try {
            return this.storeInquire.length;
        }
        catch (error) {
            console.error('Length Error', error);
        }
    };
    StoreInquireService.prototype.getNameIti = function () {
        try {
            return this.storeInquire.nameIti;
        }
        catch (error) {
            return "";
        }
    };
    StoreInquireService.prototype.getPaseengers = function () {
        try {
            return this.storeInquire.passengers;
        }
        catch (error) {
            console.error('Passengers Error', error);
        }
    };
    StoreInquireService.prototype.getStartEndDates = function () {
        try {
            return this.storeInquire.startEndDates;
        }
        catch (error) {
            console.error('Start End Date Error', error);
        }
    };
    StoreInquireService.prototype.getLogoBoat = function () {
        try {
            return this.storeInquire.logoBoat;
        }
        catch (error) {
            console.error('Logo Boat Error', error);
        }
    };
    StoreInquireService.prototype.setLogoBoat = function (value) {
        return this.storeInquire.logoBoat = value;
    };
    StoreInquireService.prototype.getImageBoat = function () {
        try {
            return this.storeInquire.imageBoat;
        }
        catch (error) {
            console.error('Image Boat Error', error);
        }
    };
    StoreInquireService.prototype.getAditionalServices = function () {
        try {
            return this.storeInquire.aditionalServices;
        }
        catch (error) {
            console.error('Array Aditional Services Error', error);
        }
    };
    StoreInquireService.prototype.getTextTempContPromotion = function () {
        try {
            return this.storeInquire.textTempContPromotion;
        }
        catch (error) {
            console.error('Text Continuation Promotion Error', error);
        }
    };
    // ============================================
    // Metodos para Paleta
    StoreInquireService.prototype.getMainColor = function () {
        try {
            return '#' + this.storePalet.mainColor;
        }
        catch (error) {
            console.error('Main Color Error', error);
        }
    };
    StoreInquireService.prototype.getSecondaryColor = function () {
        try {
            return '#' + this.storePalet.secondaryColor;
        }
        catch (error) {
            console.error('Secondary Color Error', error);
        }
    };
    StoreInquireService.prototype.getHeaderColor = function () {
        try {
            return '#' + this.storePalet.headerColor;
        }
        catch (error) {
            console.error('Header Color Error', error);
        }
    };
    StoreInquireService.prototype.getFooterColor = function () {
        try {
            return '#' + this.storePalet.footerColor;
        }
        catch (error) {
            console.error('Footer Color Error', error);
        }
    };
    StoreInquireService.prototype.getNameCompany = function () {
        try {
            return this.storePalet.name;
        }
        catch (error) {
            console.error('Footer Color Error', error);
        }
    };
    StoreInquireService.prototype.getMailCompany = function () {
        try {
            return this.storePalet.email;
        }
        catch (error) {
            console.error('Footer Color Error', error);
        }
    };
    StoreInquireService.prototype.getInfoMail = function () {
        try {
            return this.storePalet.infoEmail;
        }
        catch (error) {
            console.error('Info Mail Error', error);
        }
    };
    StoreInquireService.prototype.getLogo = function () {
        try {
            return this.storePalet.logo;
        }
        catch (error) {
            console.error('Logo Error', error);
        }
    };
    StoreInquireService.prototype.getPhoneCompany = function () {
        try {
            return this.storePalet.phone;
        }
        catch (error) {
            console.error('Phone Company Error', error);
        }
    };
    StoreInquireService.prototype.getPrivacyUrl = function () {
        try {
            return this.storePalet.privacyUrl;
        }
        catch (error) {
            console.error('Privacy Url Error', error);
        }
    };
    StoreInquireService.prototype.getWebsite = function () {
        try {
            return this.storePalet.webSite;
        }
        catch (error) {
            console.error('Website Error', error);
        }
    };
    StoreInquireService.prototype.getPrimaryColor = function () {
        try {
            return this.storeInquire.primaryColor;
        }
        catch (error) {
            console.error('Primary Color Error', error);
        }
    };
    StoreInquireService.ngInjectableDef = i0.defineInjectable({ factory: function StoreInquireService_Factory() { return new StoreInquireService(); }, token: StoreInquireService, providedIn: "root" });
    return StoreInquireService;
}());
export { StoreInquireService };
